function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F7931E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FAB535"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  fillRule: "nonzero",
  d: "M11.965 0c.386 0 .694.312.694.703v10.485c1.616.328 2.83 1.775 2.83 3.498a3.564 3.564 0 0 1-2.83 3.499v5.112c0 .39-.308.703-.694.703a.696.696 0 0 1-.694-.703v-5.112a3.564 3.564 0 0 1-2.83-3.499 3.564 3.564 0 0 1 2.83-3.498V.703c0-.39.308-.703.694-.703zM3.523 0c.386 0 .695.312.695.703v4.591a3.558 3.558 0 0 1 2.829 3.494 3.564 3.564 0 0 1-2.83 3.498v11.011c0 .39-.308.703-.694.703a.696.696 0 0 1-.694-.703V12.291A3.564 3.564 0 0 1 0 8.793a3.564 3.564 0 0 1 2.829-3.499V.703c0-.39.308-.703.694-.703zm16.954 0c.386 0 .694.312.694.703v4.59A3.552 3.552 0 0 1 24 8.786a3.563 3.563 0 0 1-2.829 3.497v11.014c0 .39-.308.703-.694.703a.696.696 0 0 1-.695-.703V12.29a3.563 3.563 0 0 1-2.829-3.498 3.563 3.563 0 0 1 2.83-3.498V.703c0-.39.308-.703.694-.703zm-8.512 12.526c-1.178 0-2.134.968-2.134 2.16 0 1.192.956 2.16 2.134 2.16s2.135-.968 2.135-2.16c0-1.192-.957-2.16-2.135-2.16zM3.523 6.632c-1.178 0-2.134.969-2.134 2.16 0 1.193.956 2.161 2.134 2.161 1.173 0 2.135-.968 2.135-2.16 0-1.192-.957-2.16-2.135-2.16zm16.954-.001c-1.178 0-2.135.968-2.135 2.16 0 1.192.957 2.16 2.135 2.16s2.134-.968 2.134-2.16c0-1.192-.956-2.16-2.134-2.16z"
});

var SvgInvestmentManage = function SvgInvestmentManage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInvestmentManage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/investment-manage.af093974.svg";
export { ForwardRef as ReactComponent };